<template>
  <div class="tw-p-4 tw-flex-1 tw-min-w-0">
    <slot />
  </div>
</template>

<script setup lang="ts">
  defineOptions({ name: 'UiCardBody' })
</script>
